import { validation, errors } from "@/helpers/validation";

const ValidationPlugin = {
  install(app) {
    app.config.globalProperties.validation = validation;
    app.config.globalProperties.errors = errors;
  },
};

export default ValidationPlugin;
